@if (showHeader && showSideBar) {
<app-header></app-header>
<app-sidebar></app-sidebar>
}
<router-outlet />
